var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.958 36.292 21.875 25.25Q20.667 26.167 19.042 26.688Q17.417 27.208 15.5 27.208Q10.667 27.208 7.292 23.833Q3.917 20.458 3.917 15.708Q3.917 10.917 7.292 7.542Q10.667 4.167 15.458 4.167Q20.25 4.167 23.604 7.542Q26.958 10.917 26.958 15.708Q26.958 17.583 26.438 19.167Q25.917 20.75 24.958 22.083L36.083 33.167ZM15.5 22.833Q18.5 22.833 20.542 20.75Q22.583 18.667 22.583 15.708Q22.583 12.708 20.521 10.625Q18.458 8.542 15.5 8.542Q12.458 8.542 10.375 10.625Q8.292 12.708 8.292 15.708Q8.292 18.667 10.375 20.75Q12.458 22.833 15.5 22.833Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchActive);
export default __webpack_public_path__ + "static/media/search_active.022a46961c5f09caf4add2de1c4aafa4.svg";
export { ForwardRef as ReactComponent };